import script from "./MyKnolia.vue?vue&type=script&setup=true&lang=js"
export * from "./MyKnolia.vue?vue&type=script&setup=true&lang=js"

import "./MyKnolia.vue?vue&type=style&index=0&id=1078bbfb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1078bbfb"]])

export default __exports__